<template>
  <div>
    <a-row>
      <g-master name="Promocion O Tranferencia"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :parentData="parentData"
                @action="masterAction"
                modalWidth="100%"
                ref="master"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-dropdown
                :label="$t('Cargos o áreas que usted recomienda puede ser promovido o trasladado actualmente')"
                :selectConfig="{mode:'multiple'}"
                :formItemConfig="fiOptions"
                endpoint="jobs"
                :decorator="['position_area', { rules: [{ required: true, message: 'Valor requerido' }] }]">
              </g-dropdown>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
  </div>
</template>

<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    props: ['id_emp'],
    data () {
      return {
        selOptions: {
          allowClear: true
        },
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'ident_poten_promocion_traslado',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'eliminar',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'delete'}
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            selectedRows: [],
            columns: [
              {
                title: 'Cargos o áreas que usted recomienda puede ser promovido o trasladado actualmente',
                align: 'center',
                dataIndex: 'cargo_desc'
              }
            ]
          }
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_emp: this.id_emp
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'eliminar':
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea eliminar el registro?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().delete('ident_poten_promocion_traslado/-1', {
                    data: {
                      id_emp: action.record.id_emp,
                      position_area: action.record.position_area
                    }
                  })
                    .then(() => {
                      this.$refs.master.$refs.datatable.loadData()
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', 'No fue posible eliminar el registro')
                      reject(error)
                    })
                })
              },
              onCancel () { }
            })
            break
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Evaluaciones/Complemento/IdentificacionPersonalPromocionTraslado.vue